export const dbNames = {
	historyDbName: "kongsberg_maritime_support_call_history",
	callConfigDbName: "kongsberg_maritime_support_call_app_config"
};
